
// src/web/components/chat-rooms-page.jsx

import React from 'react'
import connect from '../../connects/chat-rooms-page'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import Avatar from 'react-toolbox/lib/avatar'
import FontIcon from 'react-toolbox/lib/font_icon'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import Chip from 'react-toolbox/lib/chip'
import RightSidePage from './right-side-page.jsx'
import Loading from './loading.jsx'
import ConfirmDialog from './confirm-dialog.jsx'
import { mergeArray, deleteArray } from '../../helpers/store'
import chatRoomsListTheme from './themes/chat-rooms-list.css'
import successButtonTheme from './themes/success-button.css'
import _ from 'lodash'
import { InfiniteScroll } from './infinite-scroller'
import listTheme from 'react-toolbox/lib/list/theme.css'
import classnames from 'classnames'
import {linkUI, resetUI } from '../../helpers/form-validator'
import ChatRoomSettingsPage from './chat-room-settings-page.jsx';

const MAX_DISPLAY_COUNT = 13
const MAX_MEMBER_COUNT = 100

class ChatRoomsPage extends React.Component {
  state = {
    isOpen: false,
  }

  renderGroupMemberIcon = (room)=> {
    const groupMembers = _.find(this.props.chatRooms, (_chatRoom)=> _chatRoom.chat_room_id == room.chat_room_id).members
    const iconMembers = _.filter(groupMembers, (_member) => _member.user_id != this.props.user.user_id).slice(0, 3)
    const renderItem = (
      <div theme={chatRoomsListTheme} className="membersField"  >
        <img className='chatAvatar'  src={room.icon_image ? room.icon_image.thumb_url : iconMembers[0].icon_image.thumb_url}/>
          <div className="countField">
            <span key='count' className='membersCount'>{groupMembers.length >= MAX_MEMBER_COUNT ? '99+' : groupMembers.length}</span>
          </div>
      </div>)
    return renderItem
  }
  onAddUsers = () => this.props.showUserSelectionDialog(
    this.props.t('label:チャットの宛先を追加'), true, 'ACCOUNT_MEMBERS', undefined, this.props.ui.users,
    (users)=> this.props.updateUI({ users: _.filter(mergeArray('user_id', [], users), (_user)=> _user.user_id !=  this.props.user.user_id)})
  )
  render() {
    const {
      t,
      ui,
      user,
      hasMore,
      isFetching,
      isFetchFailed,
      isRequesting,
      isCreating,
      isCreateFailed,
      created,
      chatRooms,
      openChatRoom,
      deleteChatRoom,
      createChatRoom,
      fetchChatRooms,
      showUserSelectionDialog,
      updateUI,
      chatRoomNames,
    } = this.props

    return (
      <RightSidePage title={t('label:チャット')} icon="chat">
        {!isFetchFailed &&
          <div>
            {ui.users && ui.users.length > 0 &&
              <Button raised primary
                  disabled={isCreating}
                  label={t('label:チャットを開始')}
                  style={{ verticalAlign: 'bottom', mergin: '2px 5px', float: 'right' }}
                  onClick={()=> createChatRoom(this.props)} />
            }
            <Button theme={successButtonTheme}
                raised={!(ui.users && ui.users.length > 0)}
                floating={ui.users && ui.users.length > 0}
                mini={ui.users && ui.users.length > 0}
                label={!(ui.users && ui.users.length > 0) && t('label:新規作成')}
                icon='person_add'
                style={{ verticalAlign: 'bottom', mergin: '2px 5px' }}
                onClick={this.onAddUsers} />
            {ui.users && _.map(ui.users.slice(0, MAX_DISPLAY_COUNT), (user, i) => <Avatar image={user.icon_image.thumb_url} style={{ marginLeft: 2 }}/>)}
            {ui.users && ui.users.length > MAX_DISPLAY_COUNT &&  <Button
              primary
              onClick={this.onAddUsers}
              icon='arrow_forward'
              label={t('label:他n人', { n: ui.users.length - MAX_DISPLAY_COUNT }) + 'を' + t('label:すべて表示')} />}
          </div>
        }

        {!isFetchFailed && chatRooms && chatRooms.length > 0 &&
          <InfiniteScroll pageStart={0}
              element="ul"
              initialLoad={false}
              className={classnames(listTheme.list)}
              loadMore={()=> !isFetching && fetchChatRooms(this.props)}
              hasMore={hasMore}
              loader={isFetching && <ListItem caption={t('label:読み込み中')} />}
              useWindow={false} >
            { _.map(chatRoomNames, (room, i)=>
              <ListItem key={room.chat_room_id}
                  theme={chatRoomsListTheme}
                  avatar={!room.icon_image && room.thumbnail && room.thumbnail || undefined}
                  leftIcon={
                    room.icon_image ?
                      this.renderGroupMemberIcon(room)
                      :
                      room.icon && chatRooms && this.renderGroupMemberIcon(room) || undefined
                  }
                  caption={room.name}
                  onClick={()=> openChatRoom(room.chat_room_id)}
                  rightActions={[
                    room.unread_count && room.unread_count > 0 &&
                      <span key='count' className={chatRoomsListTheme.unreadCount}>{room.unread_count < 10 ? room.unread_count : '10+' }</span> || <span key="count"/>,
                    <IconButton icon='more_vert' key='icon'
                      onClick={()=> {
                        this.setState({ [room.chat_room_id]: true })
                      }} />,
                  ]} >
                  <ChatRoomSettingsPage key="page"
                    open={this.state[room.chat_room_id]}
                    chatRoom={ _.find(chatRooms, (_chatRoom)=> _chatRoom.chat_room_id == room.chat_room_id) }
                    chatRoomName={room}
                    user={user}
                    onClose={()=> this.setState({ [room.chat_room_id]: false })} />
              </ListItem>
            )}
          </InfiniteScroll>
        }

        {!isCreateFailed && chatRooms && chatRooms.length == 0 && 
          <div style={{ marginTop: '20px', textAlign: 'center'}}>{t('label:チャットの履歴がありません')}</div>
        }

        {isFetchFailed && 
          <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:チャットルームの取得に失敗しました')}</div>
        }
      </RightSidePage>
    )
  }
}

export const RawChatRoomsPage = ChatRoomsPage
export default connect(ChatRoomsPage)



// WEBPACK FOOTER //
// ./src/web/components/chat-rooms-page.jsx